import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <main
      data-testid="privacy-page"
      className="relative min-h-screen bg-obsidian text-pearl py-20 sm:py-28"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 label-overline text-ash hover:text-pearl transition-colors mb-16"
        >
          <ArrowLeft className="w-3 h-3" />
          <span>Back to Privacy</span>
        </Link>

        <h1 className="font-serif-display text-pearl text-4xl sm:text-5xl tracking-tight leading-[1.05]">
          <span className="italic text-bone">Privacy Policy</span>
        </h1>

        <div className="mt-12 space-y-8 text-ash text-[15px] leading-relaxed">
          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              What we collect at this stage
            </h2>
            <p>
              On this page, W collects only what you submit to the waitlist:
              your desired handle, your email address, and an optional note
              about why you want the handle. Standard server logs (IP, user
              agent, timestamp) are kept for security and abuse prevention.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              How we use it
            </h2>
            <p>
              We use your email solely to (1) confirm your reservation,
              (2) notify you when invitations roll out, and (3) send occasional
              founder updates about W. That's it. We never sell your email,
              never trade it, and never enrich it against third-party data.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              Your mail (after you join)
            </h2>
            <p>
              When W launches and you sign in, your email content is
              encrypted at rest and scoped to a private model context. Your
              inbox stays private. We never train AI on your emails, and your
              mail is excluded by contract from any general training corpus.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              Your rights
            </h2>
            <p>
              You can ask us to delete your reservation and email at any time
              by writing to <span className="text-bone">hello@w.xyz</span>.
              EU/UK residents have GDPR rights (access, correction, deletion,
              portability, objection); California residents have CCPA rights
              (know, delete, opt-out of sale — though we do not sell data).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              Bot protection
            </h2>
            <p>
              We use Cloudflare Turnstile to protect against spam and abuse.
              Turnstile may collect limited browser and interaction data to
              verify human users. See Cloudflare's Privacy Policy at{" "}
              <a
                href="https://www.cloudflare.com/privacypolicy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-bone underline decoration-hairline underline-offset-4 hover:text-pearl transition-colors"
              >
                cloudflare.com/privacypolicy
              </a>{" "}
              for details.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-pearl text-xl mb-3">
              Updates
            </h2>
            <p>
              This is a launch-stage notice and will be replaced by a full
              privacy policy and DPA when W moves to general availability.
              We'll email reservation holders before that takes effect.
            </p>
          </section>

          <p className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-ash pt-6 border-t border-hairline">
            Last updated · September 2026
          </p>
        </div>
      </div>
    </main>
  );
}
